var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.288,
    height: 32.899,
    viewBox: "0 0 27.288 32.899",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_57385",
    "data-name": "Group 57385",
    transform: "translate(-929.631 -444.044)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_57444",
    "data-name": "Group 57444",
    transform: "translate(929.631 444.044)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53879",
    "data-name": "Group 53879",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53872",
    "data-name": "Group 53872",
    transform: "translate(14.55 21.593)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25738",
    "data-name": "Path 25738",
    d: "M222.575,273.665a1.225,1.225,0,0,0-.344-.25,4.151,4.151,0,0,0-.871-.308v2.3a1.637,1.637,0,0,0,1.29-.68h0a1.053,1.053,0,0,0,.1-.719A.724.724,0,0,0,222.575,273.665Z",
    transform: "translate(-221.36 -273.108)",
    fill: "#2d78a6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53873",
    "data-name": "Group 53873",
    transform: "translate(15.976 23.217)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25739",
    "data-name": "Path 25739",
    d: "M242.6,299.9l0,0h0Z",
    transform: "translate(-242.604 -299.9)",
    fill: "#b57500"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53874",
    "data-name": "Group 53874",
    transform: "translate(11.38 16.733)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25740",
    "data-name": "Path 25740",
    d: "M181.6,212.677a.864.864,0,0,0-.149.405.972.972,0,0,0,.049.448.719.719,0,0,0,.279.307,2.178,2.178,0,0,0,.414.214c.121.049.257.1.4.14v-2.085A1.591,1.591,0,0,0,181.6,212.677Z",
    transform: "translate(-181.441 -212.106)",
    fill: "#2d78a6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53875",
    "data-name": "Group 53875",
    transform: "translate(15.98 23.198)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25741",
    "data-name": "Path 25741",
    d: "M242.657,299.619l-.01.017h0Z",
    transform: "translate(-242.647 -299.619)",
    fill: "#b57500"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53876",
    "data-name": "Group 53876",
    transform: "translate(16.006 23.166)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25742",
    "data-name": "Path 25742",
    d: "M243,299.245Z",
    transform: "translate(-243.004 -299.244)",
    fill: "#b57500"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53877",
    "data-name": "Group 53877",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25743",
    "data-name": "Path 25743",
    d: "M51.606,7.158c2.5-2.1,4.175-6.839,3.146-7.046-1.367-.275-4.337.932-5.772,1.145-2.036.246-4.253-2.207-5.5-.84-1.012,1.112.725,5.155,3.443,6.917-8.109,3.986-19.507,23.993.377,25.445C74.816,34.788,61.039,11.042,51.606,7.158Zm2.363,15.779A2.893,2.893,0,0,1,52.853,24.9a4.265,4.265,0,0,1-2.284.807v.862a.809.809,0,1,1-1.618,0v-.942c-.139-.026-.278-.058-.415-.1a3.973,3.973,0,0,1-1.98-1.218,3.568,3.568,0,0,1-.61-1.008c-.038-.1-.071-.194-.1-.293a1.5,1.5,0,0,1-.064-.274.809.809,0,0,1,1.573-.336c.031.093.052.189.086.281a1.8,1.8,0,0,0,.124.266,2.063,2.063,0,0,0,.355.455,2.409,2.409,0,0,0,1.03.561v-3.2a5.759,5.759,0,0,1-2.122-.917,2.469,2.469,0,0,1-.716-.861,2.694,2.694,0,0,1-.25-1.159,2.761,2.761,0,0,1,.242-1.173,2.86,2.86,0,0,1,.664-.911,4.053,4.053,0,0,1,2.182-.967v-.895a.809.809,0,1,1,1.618,0v.89q.159.02.316.048A4,4,0,0,1,53,15.846a3.088,3.088,0,0,1,.647.93,2.963,2.963,0,0,1,.114.3,1.8,1.8,0,0,1,.076.289.809.809,0,0,1-1.556.409c-.034-.088-.051-.182-.085-.27a1.426,1.426,0,0,0-.132-.255,1.544,1.544,0,0,0-.382-.4,2.623,2.623,0,0,0-1.111-.434v3.064a10.275,10.275,0,0,1,1.382.41A3.232,3.232,0,0,1,53.638,21.2c-.057-.1-.113-.2,0,0s.059.1,0,0A2.887,2.887,0,0,1,53.969,22.937Z",
    transform: "translate(-36.238 0)",
    fill: "#0378a6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_53878",
    "data-name": "Group 53878",
    transform: "translate(15.956 23.24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25744",
    "data-name": "Path 25744",
    d: "M242.346,300.169l-.009.017Z",
    transform: "translate(-242.337 -300.169)",
    fill: "#b57500"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance);
export default __webpack_public_path__ + "static/media/finance.e8447b08125561f154f0fdee9baba155.svg";
export { ForwardRef as ReactComponent };